import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import {
  SectorModel,
  SectorPayload,
} from '../../../core/models/sector.model'

@Injectable({
  providedIn: 'root',
})
export class SectorService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl
  public route = 'sectors'

  /** Liste des secteurs actifs. */
  public getAll(): Observable<SectorModel[]> {
    return this.http.get<SectorModel[]>(`${this.planifyApiUrl}/${this.route}`)
  }

  public create(payload: SectorPayload) {
    return this.http.post<{ data: SectorModel; message: string }>(
      `${this.planifyApiUrl}/${this.route}`,
      payload
    )
  }

  public update(id: number, payload: SectorPayload) {
    return this.http.put<{ data: SectorModel; message: string }>(
      `${this.planifyApiUrl}/${this.route}/${id}`,
      payload
    )
  }

  public remove(id: number) {
    return this.http.delete<{ message: string }>(
      `${this.planifyApiUrl}/${this.route}/${id}`
    )
  }
}
